import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppVersion from '../../components/AppVersion';
import '../Login/Login.css';

const MIN_PASSWORD_LENGTH = 8;

function SetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const { t: tLogin } = useTranslation('login');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (password.length < MIN_PASSWORD_LENGTH) {
      setError(tLogin('passwordTooShort'));
      return;
    }

    if (password !== confirmPassword) {
      setError(tLogin('passwordsDontMatch'));
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/post_set_password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();

      if (response.ok && data.status) {
        navigate('/', { replace: true });
      } else {
        setError(tLogin('invalidOrExpiredToken'));
      }
    } catch (err) {
      console.error('Erro ao definir senha:', err);
      setError(tLogin('setPasswordError'));
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderSideA = () => (
    <div className="image-carousel">
      <img src="/imagens/linhas.svg" className="background-svg" alt="Background Lines" />
      <img src="/imagens/logo-e-titulo-tpf.svg" className="logo-svg" alt="Logo TPF" />
    </div>
  );

  if (!token) {
    return (
      <div className="error-container">
        <img src='imagens/iris.svg' alt="Error" className="error-image" />
        <h1 className="error-title">{tLogin('mensagem-erro')}</h1>
        <p className="error-message">{tLogin('invalidOrExpiredToken')}</p>
        <AppVersion />
      </div>
    );
  }

  return (
    <div className="login-container">
      {renderSideA()}

      <div className="sideb-container show">
        <div className="form-container">
          <div className="centered-container">

            <div className="welcome-container">
              <h3 className="welcome-title">{tLogin('setPasswordTitle')}</h3>
            </div>

            <form className="forms" onSubmit={handleSubmit}>
              <div className="input-container-login">
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder={tLogin('newPassword')}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="input-field"
                  autoComplete="new-password"
                  data-testid="input-new-password"
                />
                <img src="/imagens/lock.svg" alt="" className="input-icon" />
                <img
                  src={showPassword ? '/imagens/eye-open.svg' : '/imagens/eye-closed.svg'}
                  alt=""
                  className="toggle-password-icon"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>

              <div className="input-container-login">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder={tLogin('confirmPassword')}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="input-field"
                  autoComplete="new-password"
                  data-testid="input-confirm-password"
                />
                <img src="/imagens/lock.svg" alt="" className="input-icon" />
                <img
                  src={showConfirmPassword ? '/imagens/eye-open.svg' : '/imagens/eye-closed.svg'}
                  alt=""
                  className="toggle-password-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                />
              </div>

              {!error && <p className="forgot-info-message">{tLogin('passwordRequirements')}</p>}

              {error && <p className="error-message">{error}</p>}

              <div>
                <button type="submit" className="primary-button" disabled={isSubmitting}>
                  {isSubmitting ? tLogin('submitting') : tLogin('setPasswordButton')}
                </button>
              </div>
            </form>
          </div>
        </div>

        <footer className="footer-login"></footer>
      </div>

      <AppVersion />
    </div>
  );
}

export default SetPassword;
